import type {FC} from 'react';

import {Observer} from 'mobx-react';

import {useI18n} from '@yourcoach/i18n';

import type {Props} from './types';

import {Checkbox} from '../../../../uikit/Checkbox';
import {Clickable} from '../../../../uikit/Clickable';
import {TextInput} from '../../../../uikit/TextInput';
import {ChannelsListTabs} from '../../components/ChannelsListTabs';
import * as S from './styles';

export const ChannelsListHeader: FC<Props> = ({store}) => {
  const {t} = useI18n();
  const renderTabs = () => (
    <Observer>
      {() => (
        <ChannelsListTabs
          onTabChange={tab => store.setActiveTab(tab)}
          selectedTab={store.activeTab}
          tabs={store.tabs}
        />
      )}
    </Observer>
  );

  const renderControls = () => (
    <Observer>
      {() =>
        store.isLoaded ? (
          <>
            {renderSearch()}
            {renderSelectAll()}
          </>
        ) : null
      }
    </Observer>
  );

  const renderSearch = () => (
    <Observer>
      {() =>
        !store.isEmpty || store.isSearchActive ? (
          <TextInput
            appearance="search"
            disabled={!store.isLoaded}
            inputMode="search"
            isClearable={true}
            maxLength={255}
            onChange={({payload}) => {
              store.setSearchQuery(payload?.text ?? '');
            }}
            onClear={() => store.clearSearchQuery()}
            placeholder={t('shared:search')}
            value={store.searchQuery}
          />
        ) : null
      }
    </Observer>
  );

  const renderSelectAll = () => (
    <Observer>
      {() =>
        store.isSelectAllAllowed ? (
          <S.SelectAllContainer>
            <Checkbox
              checked={store.isSelectedAll}
              indeterminate={store.hasSelectedChannels && !store.isSelectedAll}
              onClick={store.toggleSelectAll}
            />
            <Clickable onClick={store.toggleSelectAll}>
              <S.SelectAllLabel>
                {store.hasSelectedChannels
                  ? t('shared:selected_count', {
                      count: store.selectionCount,
                    })
                  : t('shared:select_all_count', {
                      count: store.selectableChannelsCount,
                    })}
              </S.SelectAllLabel>
            </Clickable>
          </S.SelectAllContainer>
        ) : null
      }
    </Observer>
  );

  return (
    <S.Container>
      {renderTabs()}
      {renderControls()}
    </S.Container>
  );
};
